import { useMutation } from "@tanstack/react-query";
import { authService } from "@/api/authService";
import { useAuth } from "@/contexts/AuthContext";

export const useLogout = () => {
  const { clearAuthState } = useAuth();

  return useMutation({
    mutationFn: authService.logout,
    onSettled: () => {
      clearAuthState();
    },
  });
};
